import { domainStore } from '@/stores/DomainStore';
import { familyStore } from '@/stores/FamilyStore';
import { hybridPedigreeStore } from '@/stores/HybridPedigreeStore';
import { uiStore } from '@/stores/UIStore';
import { invalidateApiConfiguration } from '@/services/SessionService';

/**
 * Clears all in-memory application state.
 * This should be called when a user signs out to ensure that
 * when a different user signs in using the same browser window,
 * they get their own fresh data and settings.
 *
 * This function:
 * - Clears all MobX State Tree stores (DomainStore, FamilyStore, HybridPedigreeStore, UIStore)
 * - Invalidates cached API configuration
 * - Ensures no user-specific data persists in memory
 */
export const clearAllApplicationState = (): void => {
  // Clear DomainStore (user, families metadata, selected family)
  domainStore.clear();

  // Clear FamilyStore (family graph data - people and relationships)
  familyStore.clear();

  // Clear HybridPedigreeStore (tree visualization state)
  hybridPedigreeStore.clear();

  // Clear UIStore (UI state and preferences)
  uiStore.clear();

  // Invalidate cached API configuration (tokens, etc.)
  invalidateApiConfiguration();
};
